document.addEventListener("DOMContentLoaded", function () {
  const DESKTOP_BREAKPOINT = 1100;

  const tabs = Array.from(document.querySelectorAll(".tab-link"));
  const tabTitles = Array.from(document.querySelectorAll(".tab-title"));
  const contents = Array.from(document.querySelectorAll(".tab-content"));

  if (!tabs.length && !tabTitles.length && !contents.length) return;

  const isDesktop = () => window.innerWidth > DESKTOP_BREAKPOINT;

  function getContent(tabID) {
    return document.getElementById(tabID);
  }

  function clearAll() {
    tabs.forEach(tab => tab.classList.remove("active"));
    tabTitles.forEach(title => title.classList.remove("active"));
    contents.forEach(content => {
      content.classList.remove("active");
      content.style.maxHeight = null;
    });
  }

  function updatePanelHeight(content) {
    if (!content || isDesktop()) return;

    content.style.maxHeight = "none";
    const height = content.scrollHeight;
    content.style.maxHeight = height + "px";
  }

  function updateOpenPanels() {
    if (isDesktop()) return;

    contents.forEach(content => {
      if (content.classList.contains("active")) {
        updatePanelHeight(content);
      }
    });
  }

  function openDesktopTab(tabID, clickedTab) {
    clearAll();

    if (clickedTab) clickedTab.classList.add("active");

    const content = getContent(tabID);
    if (content) {
      content.classList.add("active");
      content.style.maxHeight = null;
    }
  }

  function openMobileAccordion(title, content, doScroll = false) {
    if (!title || !content) return;

    clearAll();

    title.classList.add("active");
    content.classList.add("active");

    requestAnimationFrame(() => {
      updatePanelHeight(content);

      setTimeout(() => updatePanelHeight(content), 80);
      setTimeout(() => updatePanelHeight(content), 220);

      if (doScroll) {
        const rect = title.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.top <= window.innerHeight;

        if (!isVisible) {
          const extraOffset = 75;
          const top = window.scrollY + rect.top - extraOffset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }
    });
  }

  function initDesktop() {
    const currentActive = tabs.find(tab => tab.classList.contains("active")) || tabs[0];
    if (!currentActive) return;

    openDesktopTab(currentActive.getAttribute("data-tab"), currentActive);
  }

  function initMobile() {
    const currentActive = tabTitles.find(title => title.classList.contains("active")) || tabTitles[0];
    if (!currentActive) return;

    const tabID = currentActive.getAttribute("data-tab");
    const content = getContent(tabID);

    openMobileAccordion(currentActive, content, false);
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      if (!isDesktop()) return;

      const tabID = this.getAttribute("data-tab");
      openDesktopTab(tabID, this);
    });
  });

  tabTitles.forEach(title => {
    title.addEventListener("click", function () {
      if (isDesktop()) return;

      const tabID = this.getAttribute("data-tab");
      const content = getContent(tabID);
      const isAlreadyActive = this.classList.contains("active");

      if (isAlreadyActive) {
        clearAll();
        return;
      }

      openMobileAccordion(this, content, true);
    });
  });

  let lastMode = isDesktop() ? "desktop" : "mobile";

  function handleResize() {
    const currentMode = isDesktop() ? "desktop" : "mobile";

    if (currentMode !== lastMode) {
      lastMode = currentMode;

      if (currentMode === "desktop") {
        initDesktop();
      } else {
        initMobile();
      }
    } else if (currentMode === "mobile") {
      updateOpenPanels();
    }
  }

  window.addEventListener("resize", handleResize);
  window.addEventListener("load", updateOpenPanels);

  document.querySelectorAll(".tab-content iframe, .tab-content img, .tab-content video").forEach(el => {
    el.addEventListener("load", updateOpenPanels);
  });

  if (isDesktop()) {
    initDesktop();
  } else {
    initMobile();
  }
});